exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart[data-v-6c8a83fe] {\n  width: 100%;\n}\n", ""]);

// exports
